<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>
    <div :class="{ 'blur-content': this.isLoading }">
      <div class="main-wrapper">
        <!--begin::sidebar-->
        <sidebar-component classMenu="TransportOrderCt"></sidebar-component>
        <!--end::sidebar-->

        <div class="page-wrapper">
          <!--begin::navbar-->
          <navbar-component></navbar-component>
          <!--end::navbar-->

          <!--begin::content-->
          <div class="page-content">

            <div>
              <h4 style="margin-right: 5px" class="float-start"></h4>
              <h4 class="mb-12 mb-md-0">
                <span style="text-transform: uppercase">POD {{ typePOD }}</span>
              </h4>
              <br />
            </div>

            <div class="col-lg-12 col-xl-12 stretch-card">
              <div class="card">
                <div class="card-header">
                  <div class="row">
                    <div class="col-lg-4">
                      <!--Datepicker
                                    v-model="filtertanggal"
                                    :bootstrap-styling=true
                                    format="dd-MM-yyyy"
                                    placeholder="Please Select Date..."
                         ></Datepicker-->
                      <date-range-picker style="width: 100%" control-container-class="form-control"
                        :locale-data="locale" v-model="dateFilter" :opens="opens" :singleDatePicker="false"
                        :timePicker24Hour="true" :timePicker="true" :showWeekNumbers="false">
                      </date-range-picker>


                    </div>

                    <div class="col-lg-2">
                      <button type="button" style="max-height: 40px;" @click.prevent="loadItems"
                        class="btn btn-primary btn-icon-text mb-2 mb-md-0 btn-block btn-floating">
                        GO
                      </button>
                    </div>
                    <!-- <div class="col-lg-2"> -->

                    <!-- <button
                        v-if="permision_role.method_read"
                        class="btn btn-success float-end btn-xs"
                        style="margin-right: 5px"
                        @click.prevent="downloadData()"
                      >
                        <i class="link-icon" data-feather="download"></i>
                        {{ $t("downloadData") }} KPI .xlsx
                      </button> -->
                    <!-- </div>       -->


                    <div class="col-lg-3">

                      <button v-if="permision_role.method_read" class="btn btn-success float-end btn-xs"
                        style="margin-right: 5px" @click.prevent="downloadData()">
                        <i class="link-icon" data-feather="download"></i>
                        {{ $t("downloadData") }} Report .xlsx
                      </button>
                    </div>


                    <!-- <div class="col-lg-3">

                      <button v-if="permision_role.method_read" class="btn btn-warning float-end btn-xs"
                        style="margin-right: 5px" @click.prevent="downloadDataKPI()">
                        <i class="link-icon" data-feather="download"></i>
                        {{ $t("downloadData") }} KPI
                      </button>
                    </div> -->




                  </div>


                </div>

                <div class="card-body">
                  <div class="row">
                          <div class="col-md-6">
                                <!-- Input pencarian -->
                                <div class="input-group">
                                  <input type="text" @paste="handlePaste($event)"  class="form-control" v-model="txtsearchingLoadId" placeholder="Search by Load ID..." id="searchInput">
                                  <button class="btn btn-primary" v-on:click="searchLoadid()" type="button" id="btnSearch">
                                    <i class="bi bi-search"></i> Search
                                  </button>
                                </div>
                              </div>
                          </div>
                  <div class="table-responsive" >
                    <div class="col-sm-12">
                          

                      <vue-good-table title="list-order-ct" mode="remote" @on-page-change="onPageChange"
                        @on-sort-change="onSortChange" @on-column-filter="onColumnFilter"
                        @on-per-page-change="onPerPageChange" :totalRows="totalRecords" :line-numbers="true"
                        :isLoading.sync="isLoading" :pagination-options="{
                          enabled: true,
                          dropdownAllowAll: false,
                        }" :select-options="{
                                enabled: true,
                                selectOnCheckboxOnly: true,
                                selectionText: $t('data_selected'),
                                clearSelectionText: $t('clear'),
                              }" @on-selected-rows-change="selectionChanged" :rows="rows" :columns="typePOD=='vendor' ? columnsVendor : columns"
                        row-key-field="__rowIndex">


                        <div slot="selected-row-actions">
                          <button v-if="permision_role.method_update" class="btn btn-danger btn-xs" @click="openBulkTanggal()">UBAH TANGGAL</button>
                        </div>



                        <template slot="table-row" slot-scope="props">
                          <span v-if="props.column.field == 'action'">

                            <a v-if="editingRowId === props.index && permision_role.method_update" style="color: #ab0635;text-decoration: none; cursor:pointer"
                               title="CloseEdit" @click.prevent="
                                closeEdit()
                                ">
                              <i class="mdi mdi-close" style="font-size:16px"></i>

                            </a>


                            <template v-if="editingRowId !== props.index && permision_role.method_update">
                              <a style="color:#ab0635; cursor:pointer" title="Edit"
                                @click.prevent="editData(props.row, props.index)">
                                <i class="mdi mdi-square-edit-outline" style="font-size:16px"></i> 
                              </a>
                            </template>

                            <!-- MODE SAVE -->
                            <template v-else>
                              <a v-if="permision_role.method_update" style="color:green;cursor: pointer;" title="Save" @click.prevent="saveRow(props.row)">
                                <i class="mdi mdi-check-bold" style="font-size:18px"></i>
                              </a>
                            </template>

                          </span>
                          <span v-else-if="props.column.field == 'status'">
                            <b>{{ props.row.create_by == "system" ? "Updated" : "Submited" }}</b>
                          </span>

                          <span v-else-if="props.column.field == 'tanggal_bongkar' && typePOD == 'vendor'">
                            <template v-if="editingRowId === props.index">
                              <input type="date" class="form-control form-control-sm"
                                v-model="editForm.tanggal_bongkar" />
                            </template>
                            <template v-else>
                              {{ formatToDisplayDate(props.formattedRow.tanggal_bongkar) }}
                            </template>
                          </span>


                          <span v-else-if="props.column.field == 'tanggal_epod_vendor' && typePOD == 'vendor'">
                            <template v-if="editingRowId === props.index">
                              <input type="date" class="form-control form-control-sm"
                                v-model="editForm.tanggal_epod_vendor" />
                            </template>
                            <template v-else>
                              {{ formatToDisplayDate(props.formattedRow.tanggal_epod_vendor) }}
                            </template>
                          </span>

                          <span v-else-if="props.column.field == 'tgl_terima_sj_di_customer'">
                            <template v-if="editingRowId === props.index">
                              <input type="date" class="form-control form-control-sm"
                                v-model="editForm.tgl_terima_sj_di_customer" />
                            </template>
                            <template v-else>
                              {{ formatToDisplayDate(props.formattedRow.tgl_terima_sj_di_customer) }}
                            </template>
                          </span>


                          <span v-else-if="props.column.field == 'tgl_terima_sj_di_pool'">
                            <template v-if="editingRowId === props.index">
                              <input type="date" class="form-control form-control-sm"
                                v-model="editForm.tgl_terima_sj_di_pool" />
                            </template>
                            <template v-else>
                              {{ formatToDisplayDate(props.formattedRow.tgl_terima_sj_di_pool) }}
                            </template>
                          </span>


                          <span v-else-if="props.column.field == 'tgl_serah_terima_di_billing'">
                            <template v-if="editingRowId === props.index">
                              <input type="date" class="form-control form-control-sm"
                                v-model="editForm.tgl_serah_terima_di_billing" />
                            </template>
                            <template v-else>
                              {{ formatToDisplayDate(props.formattedRow.tgl_serah_terima_di_billing) }}
                            </template>
                          </span>



                          <span v-else-if="props.column.field == 'keterangan'">
                            <template v-if="editingRowId === props.index">
                              <input type="text" class="form-control form-control-sm" v-model="editForm.keterangan" />
                            </template>
                            <template v-else>
                              {{ props.formattedRow.keterangan }}
                            </template>
                          </span>


                          


                          <span v-else>
                            {{ props.formattedRow[props.column.field] }}
                          </span>
                        </template>
                      </vue-good-table>

                    </div>
                  </div>
                </div>

              </div>
            </div>



          </div>
          <!--end::content-->


          <!--begin::footer-->
          <footer-component></footer-component>
          <!--end::footer-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
//import Datepicker from "vuejs-datepicker";

import DateRangePicker from "vue2-daterange-picker";
import moment from 'moment';

export default {
  name: "DriverAttendance",
  components: {
    "sidebar-component": sidebarComponent,
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    //Datepicker,
    DateRangePicker,
  },
  data() {
    const startDate = moment().clone().startOf('month').format('YYYY-MM-DD'); // new Date();
    const endDate = new Date();

    return {

      editingRowId: null,
      txtsearchingLoadId:"",
      loadIdRowId: null,     // id baris yang sedang diedit
      editForm: {             // form sementara per row
        tgl_terima_sj_di_customer: null,
        tgl_terima_sj_di_pool: null,
        tgl_serah_terima_di_billing: null,
        tanggal_bongkar: null,
        tanggal_epod_vendor:null,
  
      },

      opens: "center",
      locale: {
        format: "yyyy-mm-dd",
      },
      typePOD: "",
      showModalRecap: false,
      dataModal: {},
      maxToasts: 100,
      filtertanggal: new Date(),
      dateFilter: {
        startDate,
        endDate,
      },
      position: "up right",
      closeBtn: true,
      isLoading: false,
      errors: [],
      permision_role: [],
      permision_role_vendor:[],
      langs: ["id", "en"],
      detailUser: [],
      detailDivisi: [],
      totalRecords: 0,
      serverParams: {
        // columnFilters: {},
        sort: {
          field: "",
          type: "",
        },
        page: 1,
        per_page: 10,
      },
      columns: [
        {

          label: "Action",
          field: "action",
          sortable: false,
        },


        //  {
        //   label: "Tanggal EPOD",
        //   field: "tanggal_epod_vendor",
        //   sortable: false,
        //   filterOptions: {
        //     enabled: true, // enable filter for this column
        //     placeholder: "Filter By ", // placeholder for filter input
        //     filterValue: "", // initial populated value for this filter
        //     filterDropdownItems: [], // dropdown (with selected values) instead of text input
        //     trigger: "enter", //only trigger on enter not on keyup
        //   },
        // },

        {
          label: "Tgl Bongkar",
          field: "tanggal_bongkar",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


       

        {
          label: "Tgl Terima SJ di Pool",
          field: "tgl_terima_sj_di_pool",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


        {
          label: "Tgl Terima SJ di Cust",
          field: "tgl_terima_sj_di_customer",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


        {
          label: "Tgl Terima Serah Terima Billing",
          field: "tgl_serah_terima_di_billing",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


      


        {
          label: "Keterangan",
          field: "keterangan",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: "Customer",
          field: "customer",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: "Load ID",
          field: "load_id",
          sortable: false,
          // filterOptions: {
          //   enabled: true, // enable filter for this column
          //   placeholder: "Filter By ", // placeholder for filter input
          //   filterValue: "", // initial populated value for this filter
          //   filterDropdownItems: [], // dropdown (with selected values) instead of text input
          //   trigger: "enter", //only trigger on enter not on keyup
          // },
        },

        {
          label: "Carrier",
          field: "carrier",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: "Nopol",
          field: "vehicle_no",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: "NMK",
          field: "nmk_driver",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


        {
          label: "Driver Name",
          field: "driver_name",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


        {
          label: "Type Truck",
          field: "type_truck",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: "Order No",
          field: "order_no",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: "Order Base",
          field: "order_base",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


        {
          label: "Origin",
          field: "pick_name",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "Destination",
          field: "drop_name",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


        {
          label: "TMS Status",
          field: "status_tms",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: "Pick Plan",
          field: "pick_plan",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


       


        {
          label: "Tgl Epod LincDriver",
          field: "approved_time",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


        {
          label: "Aging Load Id",
          field: "aging",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


        






      ],

      columnsVendor: [
        {

          label: "Action",
          field: "action",
          sortable: false,
        },


         {
          label: "Tanggal EPOD",
          field: "tanggal_epod_vendor",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: "Tgl Bongkar",
          field: "tanggal_bongkar",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


       

        {
          label: "Tgl Terima SJ di Pool",
          field: "tgl_terima_sj_di_pool",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


        {
          label: "Tgl Terima SJ di Cust",
          field: "tgl_terima_sj_di_customer",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


        {
          label: "Tgl Terima Serah Terima Billing",
          field: "tgl_serah_terima_di_billing",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },




        {
          label: "Keterangan",
          field: "keterangan",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: "Customer",
          field: "customer",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: "Load ID",
          field: "load_id",
          sortable: false,
          // filterOptions: {
          //   enabled: true, // enable filter for this column
          //   placeholder: "Filter By ", // placeholder for filter input
          //   filterValue: "", // initial populated value for this filter
          //   filterDropdownItems: [], // dropdown (with selected values) instead of text input
          //   trigger: "enter", //only trigger on enter not on keyup
          // },
        },

        {
          label: "Carrier",
          field: "carrier",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: "Nopol",
          field: "vehicle_no",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: "NMK",
          field: "nmk_driver",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


        {
          label: "Driver Name",
          field: "driver_name",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


        {
          label: "Type Truck",
          field: "type_truck",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: "Order No",
          field: "order_no",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: "Order Base",
          field: "order_base",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


        {
          label: "Origin",
          field: "pick_name",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "Destination",
          field: "drop_name",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


        {
          label: "TMS Status",
          field: "status_tms",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: "Pick Plan",
          field: "pick_plan",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


       


        {
          label: "Tgl Epod LincDriver",
          field: "approved_time",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


        {
          label: "Aging Load Id",
          field: "aging",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


       






      ],
      rows: [],
    };
  },
  watch: {},
  computed: {
  },
  methods: {
    closeMyModal() {
      this.showModalRecap = false;
      this.loadItems();
    },



    formatToInputDate(date) {

      if (
        !date ||
        date === '0000-00-00' ||
        date === '0000-00-00 00:00:00'
      ) {
        return '';
      }

      const m = moment(date);
      return m.isValid() ? m.format('YYYY-MM-DD') : '';
    },

    formatToDisplayDate(date) {

      if (
        !date ||
        date === '0000-00-00' ||
        date === '0000-00-00 00:00:00'
      ) {
        return '-';
      }

      const m = moment(date);
      return m.isValid() ? m.format('DD/MM/YYYY') : '-';
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      let rolePermision_vendor = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == 'PODController') {
          rolePermision = permision;
        }


        if (permision.permission.controller == 'PODVendorController') {
          rolePermision_vendor = permision;
        }

      });


        const pod = userDatas.sub.permision_role.find(
          p => p.permission.controller === 'PODController'
        );

        const vendor = userDatas.sub.permision_role.find(
          p => p.permission.controller === 'PODVendorController'
        );

        const hasAccess =
          pod?.method_custom1 === 1 ||
          vendor?.method_custom1 === 1;

        if (!hasAccess) {
          this.$router.push('/authorized-error');
        }

      // if (!rolePermision.method_custom1) {
      //   this.$router.push("/authorized-error");
      // }


      // if (!rolePermision_vendor.method_custom1) {
      //   this.$router.push("/authorized-error");
      // }
      this.permision_role_vendor =rolePermision_vendor 
      this.permision_role = rolePermision;

      if (this.$route.query.msg) {
        if (this.$route.query.status == 200) {
          this.success(this.$route.query.msg)
        } else {
          this.error(this.$route.query.msg)
        }

      }

    },


    resetEditState() {
      this.editingRowId = null;
      this.loadIdRowId = null;
      this.editForm = {
        tgl_terima_sj_di_customer: null,
        tgl_terima_sj_di_pool: null,
        tgl_serah_terima_di_billing: null,
        tanggal_bongkar: null,
        keterangan: null,
        
      };
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
    },


    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
      this.loadItems();
    },

    onColumnFilter(params) {
      params.page = 1;
      this.updateParams(params);
    },

    handlePaste(e) {
      e.preventDefault();

      let text = (e.clipboardData || window.clipboardData).getData('text');
      text = text.trim().replace(/\s+/g, ',');

      this.txtsearchingLoadId = text;
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field,
        },
      });
    },

   searchLoadid(){
    this.loadItems();
   },

   openBulkTanggal() {
  if (!this.rowsSelection || this.rowsSelection.length === 0) {
    this.error('Pilih minimal 1 data');
    return;
  }

  this.$swal.fire({
    title: 'Update Tanggal Terpilih (Bulk)',
    width: 520,
    html: `
      <table style="width:100%; text-align:left;">


        ${
          this.typePOD === 'vendor'
            ? `
            <tr>
              <td style="padding-bottom:8px;">Tgl Epod</td>
              <td style="padding-bottom:8px;">
                <input id="tgl_epod" type="date" class="swal2-input" style="margin:0;">
              </td>
            </tr>
            `
            : ''
        }

        <tr>
          <td style="padding-bottom:8px; width:45%;">Tgl Terima SJ di Pool</td>
          <td style="padding-bottom:8px;">
            <input id="sj_pool" type="date" class="swal2-input" style="margin:0;">
          </td>
        </tr>

        <tr>
          <td style="padding-bottom:8px;">Tgl Terima SJ di Customer</td>
          <td style="padding-bottom:8px;">
            <input id="sj_customer" type="date" class="swal2-input" style="margin:0;">
          </td>
        </tr>

        <tr>
          <td style="padding-bottom:8px;">Tgl Serah Terima Billing</td>
          <td style="padding-bottom:8px;">
            <input id="billing" type="date" class="swal2-input" style="margin:0;">
          </td>
        </tr>

      

        ${
          this.typePOD === 'vendor'
            ? `
            <tr>
              <td style="padding-bottom:8px;">Tgl Bongkar</td>
              <td style="padding-bottom:8px;">
                <input id="bongkar" type="date" class="swal2-input" style="margin:0;">
              </td>
            </tr>
            `
            : ''
        }
      </table>
    `,
    showCancelButton: true,
    confirmButtonText: 'Simpan',
    focusConfirm: false,
    preConfirm: () => ({
      tgl_terima_sj_di_pool: document.getElementById('sj_pool').value || null,
      tgl_terima_sj_di_customer: document.getElementById('sj_customer').value || null,
      tgl_serah_terima_di_billing: document.getElementById('billing').value || null,
      
      tanggal_bongkar:
        this.typePOD === 'vendor'
          ? document.getElementById('bongkar')?.value || null
          : null,
      tanggal_epod_vendor:
        this.typePOD === 'vendor'
          ? document.getElementById('tgl_epod')?.value || null
          : null,
    }),
  }).then((result) => {
    if (result.isConfirmed) {
      this.submitBulkTanggal(result.value);
    }
  });
},





submitBulkTanggal(form) {
  const payload = {
    data: this.rowsSelection.map(row => {
      const item = {
        load_id: row.load_id,
        tgl_terima_sj_di_pool: form.tgl_terima_sj_di_pool,
        tgl_terima_sj_di_customer: form.tgl_terima_sj_di_customer,
        tgl_serah_terima_di_billing: form.tgl_serah_terima_di_billing,
      };

      if (this.typePOD === 'vendor') {
        item.tanggal_bongkar = form.tanggal_bongkar;
        item.tgl_epod=form.tanggal_epod_vendor
      }

      return item;
    })
  };

  this.isLoading = true;

  this.$http.post(
    this.$settings.endPoint + `pod/${this.typePOD}/update-mass`,
    payload
  )
  .then(() => {
    this.success('Tanggal berhasil diupdate');
    this.loadItems(); // refresh table
  })
  .catch(() => {
    this.error('Gagal update tanggal');
  })
  .finally(() => {
    this.isLoading = false;
  });
},



    downloadData() {
     
      var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
      var file_name = "download_report_pod" + CurrentDate + ".xlsx";
      this.typePOD = this.$route.query.type;
      let dataSend = {
        start: moment(String(this.dateFilter.startDate,)).format('YYYY-MM-DD'), //this.dateFilter.startDate,  // moment(String(this.forms.join_date)).format('YYYY-MM-DD');
        end: moment(String(this.dateFilter.endDate,)).format('YYYY-MM-DD'),
      };
      //let tanggal = this.filtertanggal.toISOString().split('T')[0]
      var filterVendor="";
      if(this.typePOD=='vendor'){
        filterVendor=`&tanggal_epod_vendor=${this.serverParams.columnFilters.tanggal_epod_vendor}`;
      }
      this.isLoading = true;
      const baseURI = this.$settings.endPoint + `pod/${this.typePOD}?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&pick_plan=${dataSend.start}~${dataSend.end}${filterVendor}&load_id=${this.txtsearchingLoadId}&customer=${this.serverParams.columnFilters.customer}&carrier=${this.serverParams.columnFilters.carrier}&vehicle_no=${this.serverParams.columnFilters.vehicle_no}&driver_name=${this.serverParams.columnFilters.driver_name}&type_truck=${this.serverParams.columnFilters.type_truck}&order_no=${this.serverParams.columnFilters.order_no}&nmk_driver=${this.serverParams.columnFilters.nmk_driver}&order_base&pick_name&drop_name&status_tms&tanggal_bongkar=${this.serverParams.columnFilters.tanggal_bongkar}&tgl_terima_sj_di_pool=${this.serverParams.columnFilters.tgl_terima_sj_di_pool}&tgl_terima_sj_di_customer=${this.serverParams.columnFilters.tgl_terima_sj_di_customer}&tgl_serah_terima_di_billing=${this.serverParams.columnFilters.tgl_serah_terima_di_billing}&download=download`;



      //var columnFilters = this.serverParams.columnFilters;


      return this.$http
        .get(
          baseURI,
          {
            responseType: "blob",
          }
        )
        .then((response) => {

          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.fade(false);
        });
    },




    downloadDataKPI() {
      let dataSend = {
        start: moment(String(this.dateFilter.startDate,)).format('YYYY-MM-DD'), //this.dateFilter.startDate,  // moment(String(this.forms.join_date)).format('YYYY-MM-DD');
        end: moment(String(this.dateFilter.endDate,)).format('YYYY-MM-DD'),
      };
      //let tanggal = this.filtertanggal.toISOString().split('T')[0]
      const baseURI = this.$settings.endPoint + `pod/${this.typePOD}?start=${dataSend.start}&end=${dataSend.end}&download=kpi`;
     //var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
      //var file_name = "download_report_pod_kpi" + CurrentDate + ".xlsx";

      //var columnFilters = this.serverParams.columnFilters;


      return this.$http
        .get(
          baseURI,
         
        )
        .then((response) => {
      
          this.success(response.data.datas.messages);
          this.isLoading = false;
        }).catch(error => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {

            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 500) {
                this.$router.push('/server-error');
              } else if (error.response.status === 401) {
                this.$router.push("/authorized-error");
              } else {
                this.$router.push('/page-not-found');
              }
            }

          }

        });
    },



    onPerPageChange(params) {
      this.updateParams({ per_page: params.currentPerPage });
    },


    selectionChanged(ev) {
      this.rowsSelection = [];
      this.rowsSelection = ev.selectedRows;
      this.claim_ids = [];
      this.rowsSelection.forEach((item) => {
        console.log(item);


      });
      console.log(this.claim_ids);
    },

    updateFormatDate(date) {
      let date_format = this.$moment(date).format("dd mmm yyyy");
      return date_format;
    },

    // editData(row) {

    //   let dataSend = {
    //           start: moment(String(this.dateFilter.startDate,)).format('YYYY-MM-DD'), //this.dateFilter.startDate,  // moment(String(this.forms.join_date)).format('YYYY-MM-DD');
    //           end: moment(String(this.dateFilter.endDate,)).format('YYYY-MM-DD'),
    //       };


    //   var params = this.$onRandom(row.transport_order_header_id);
    //   this.$root.$router.push({
    //         path: `/ct-orders/pod-form-update/`+params+`?start=${dataSend.start}&end=${dataSend.end}` ,
    //   })

    // },
    closeEdit(){
      this.resetEditState();
    },

    editData(row, rowIndex) {
      // toggle off
      if (this.editingRowId === rowIndex) {
        this.resetEditState();
        return;
      }

      // tutup edit lain
      this.resetEditState();

      // buka edit hanya baris ini
      this.editingRowId = rowIndex;

      this.editForm = {
        tgl_terima_sj_di_customer:  this.formatToInputDate(row.tgl_terima_sj_di_customer) ?? null,
        tgl_terima_sj_di_pool:  this.formatToInputDate(row.tgl_terima_sj_di_pool) ?? null,
        tgl_serah_terima_di_billing:  this.formatToInputDate(row.tgl_serah_terima_di_billing) ?? null,
        keterangan: row.keterangan ?? null,
        tanggal_bongkar: null,
      };

      if (this.typePOD === 'vendor') {
        this.editForm.tanggal_bongkar =  this.formatToInputDate(row.tanggal_bongkar) ?? null;
        this.editForm.tanggal_epod_vendor= this.formatToInputDate(row.tanggal_epod_vendor) ?? null;
       
      }
    },



    saveRow(row) {
      this.isLoading = true;

      var payload = {
        transport_order_header_id: row.transport_order_header_id ,
        tgl_terima_sj_di_customer: this.editForm.tgl_terima_sj_di_customer,
        tgl_terima_sj_di_pool: this.editForm.tgl_terima_sj_di_pool,
        tgl_serah_terima_di_billing: this.editForm.tgl_serah_terima_di_billing,
        keterangan: this.editForm.keterangan
      };


      if (this.typePOD == 'vendor') {
        payload = {
          transport_order_header_id: row.transport_order_header_id,
          tgl_terima_sj_di_customer: this.editForm.tgl_terima_sj_di_customer,
          tgl_terima_sj_di_pool: this.editForm.tgl_terima_sj_di_pool,
          tgl_serah_terima_di_billing: this.editForm.tgl_serah_terima_di_billing,
          tanggal_bongkar: this.editForm.tanggal_bongkar + ' 00:00:00',
          tgl_epod:this.editForm.tanggal_epod_vendor,
          keterangan: this.editForm.keterangan
        };
      }

      this.$http.put(
        this.$settings.endPoint + `pod/${this.typePOD}/update/${row.load_id}`,
        payload
      )
        .then(() => {
          // update UI tanpa reload


          this.loadItems();
          this.resetEditState();
          this.success('Tanggal berhasil disimpan');
        })
        .catch(() => {
          Object.assign(row, this.editForm);
          this.resetEditState();
          this.error('Gagal menyimpan data');
        })
        .finally(() => {
          Object.assign(row, this.editForm);
          this.resetEditState();
          this.isLoading = false;
        });
    },


    viewData(row) {
      var params = this.$onRandom(row.transport_order_header_id);
      this.$root.$router.push({
        path: `/ct-orders/pod-form-view/` + params,
      })
      // var params = this.$onRandom(row.transport_order_header_id);
      // window.location.href = "/ct-orders/edit/" + params;
    },



    newData() {
      let dataSend = {
        start: moment(String(this.dateFilter.startDate,)).format('YYYY-MM-DD'), //this.dateFilter.startDate,  // moment(String(this.forms.join_date)).format('YYYY-MM-DD');
        end: moment(String(this.dateFilter.endDate,)).format('YYYY-MM-DD'),
      };
      this.$root.$router.push({
        path: `/ct-orders/pod-form-create?start=${dataSend.start}&end=${dataSend.end}`,
      })
      //   window.location.href = "/absensidriver";
    },

    detailData() {
      window.location.href = "/truckUtilitationReport";
    },


    // load items is what brings back the rows from server
    loadItems() {
      this.typePOD = this.$route.query.type;
      let dataSend = {
        start: moment(String(this.dateFilter.startDate,)).format('YYYY-MM-DD'), //this.dateFilter.startDate,  // moment(String(this.forms.join_date)).format('YYYY-MM-DD');
        end: moment(String(this.dateFilter.endDate,)).format('YYYY-MM-DD'),
      };
      //let tanggal = this.filtertanggal.toISOString().split('T')[0]
      var filterVendor="";
      if(this.typePOD=='vendor'){
        filterVendor=`&tanggal_epod_vendor=${this.serverParams.columnFilters.tanggal_epod_vendor}`;
      }

      // if(this.txtsearchingLoadId==null){
      //   this.txtsearchingLoadId=this.serverParams.columnFilters.load_id;
      // }

      this.isLoading = true;
      const baseURI = this.$settings.endPoint + `pod/${this.typePOD}?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&pick_plan=${dataSend.start}~${dataSend.end}${filterVendor}&load_id=${this.txtsearchingLoadId}&customer=${this.serverParams.columnFilters.customer}&carrier=${this.serverParams.columnFilters.carrier}&vehicle_no=${this.serverParams.columnFilters.vehicle_no}&driver_name=${this.serverParams.columnFilters.driver_name}&type_truck=${this.serverParams.columnFilters.type_truck}&order_no=${this.serverParams.columnFilters.order_no}&nmk_driver=${this.serverParams.columnFilters.nmk_driver}&order_base&pick_name&drop_name&status_tms&tanggal_bongkar=${this.serverParams.columnFilters.tanggal_bongkar}&tgl_terima_sj_di_pool=${this.serverParams.columnFilters.tgl_terima_sj_di_pool}&tgl_terima_sj_di_customer=${this.serverParams.columnFilters.tgl_terima_sj_di_customer}&tgl_serah_terima_di_billing=${this.serverParams.columnFilters.tgl_serah_terima_di_billing}`;

      return this.$http
        .get(
          baseURI,
          // +
          // `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&company_name=${company_name}&transport_order_template_tonnage=${transport_order_template_tonnage}&transport_order_template_cubic=${transport_order_template_cubic}&transport_order_template_description=${transport_order_template_description}&order_status=${this.serverParams.columnFilters.order_status}&order_no=${this.serverParams.columnFilters.order_no}&postpone_time=${this.serverParams.columnFilters.postpone_time}&drop_name=${this.serverParams.columnFilters.drop_name}&order_date=${date_order}`,
          { timeout: 10000 }
        )
        .then((response) => {
          this.rows = response.data.datas.data;
          console.log(this.rows);
          this.totalRecords = response.data.datas.total;
          this.isLoading = false;
        }).catch(error => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {

            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 500) {
                this.$router.push('/server-error');
              } else if (error.response.status === 401) {
                this.$router.push("/authorized-error");
              } else {
                this.$router.push('/page-not-found');
              }
            }

          }

        });
    },


    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    success2(msg) {
      // let pesan="";
      // msg.forEach((item) => {
      //     pesan=pesan+"<p>* "+item+"</p>";
      // });

      this.$swal({
        icon: 'info',
        backdrop: true,
        title: "Information",
        html: msg,
        showConfirmButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false
      })


    },

    loadingSubmiting() {

      this.$swal({
        icon: 'warning',
        backdrop: true,
        title: "Please wait",
        html: '<h2>SUBMITTING ORDER...</h2>',
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })

    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.isLoading = false;
      }, 1000); // hide the message after 3 seconds
    },

  },
  events: {},
  created: function () { },
  mounted() {
    this.typePOD = this.$route.query.type;

    this.fetchIt();
    this.loading();

    //console.log(this.$route.query.type);

    //


  },
};
</script>
<style scoped>
.blur-content {
  filter: blur(5px);
  pointer-events: none;
}

.card-body {
  padding: 5px 1.5rem 1rem;
}

.vgt-table th {
  text-align: left !important;
}

.toggleFilterClass {
  display: none !important;
}
</style>